import { axiosInstance } from "../instance"

export interface GuestInvitation {
  id: number
  first_name: string
  last_name: string
  suffix: string
  hash: string
  phone: string
  status: number
  zone: number | string
  event_name: string
  guests_number_max: number
  guests_number_actual: number | null
  scanned_guests_number: number
  event: {
    data: Array<{
      event_id: number
      name: string
      host_name: string
      due_date: string
      start_datetime: string
      address: {
        address: string
        lat: string
        lng: string
      }
      venue: string
      status: number
    }>
  }
}

/**
 * Fetch invitation details by hash and event_id
 * This is called when a QR code is scanned
 */
export const getInvitationByHash = async (hash: string, eventId: string): Promise<GuestInvitation> => {
  const response = await axiosInstance.get<{ data: GuestInvitation }>(
    `/scanner/guests/${hash}`,
    {
      params: { event_id: eventId }
    }
  )
  return response.data.data
}

/**
 * Check in guests
 */
export const checkInGuests = async (params: {
  guestHash: string
  event_id: string | number
  guests_number_to_check_in: number
}): Promise<GuestInvitation> => {
  const response = await axiosInstance.post<{ data: GuestInvitation }>(
    `/scanner/guests/${params.guestHash}/check-in`,
    {
      event_id: params.event_id.toString(),
      guests_number_to_check_in: params.guests_number_to_check_in,
    }
  )
  return response.data.data
}

/**
 * Check out guests
 */
export const checkOutGuests = async (params: {
  guestHash: string
  event_id: string | number
  guests_number_to_check_out: number
}): Promise<GuestInvitation> => {
  const response = await axiosInstance.post<{ data: GuestInvitation }>(
    `/scanner/guests/${params.guestHash}/check-out`,
    {
      event_id: params.event_id.toString(),
      guests_number_to_check_out: params.guests_number_to_check_out,
    }
  )
  return response.data.data
}
